const translations = {
  "nav.pricing": "الأسعار",
  "nav.features": "كيف يعمل",
  "nav.support": "الدعم",
  "nav.contact": "تواصل معنا",
  "hero.badge": "ضمان الرضا أو استرداد المال",
  "hero.title1": "سينماك التلفزيونية",
  "hero.title2": "اللامحدودة في المنزل!",
  "hero.desc": "استمتع بوصول غير محدود إلى <b>+25,000 قناة مباشرة</b> و<b>+70,000 فيلم ومسلسل</b> بجودة HD/4K — <b>0 انقطاع، 0 تجمد</b>. فريقنا متاح <b>7 أيام/7 من 10 صباحاً إلى 12 منتصف الليل</b>. جرّب مجاناً وانضم إلى آلاف العملاء الراضين!",
  "hero.cta_primary": "جرّب الآن",
  "hero.cta_secondary": "تواصل معنا",
  "hero.rating_text": "– +10,000 عميل",
  "hero.feature_trial": "تجربة مجانية 24 ساعة",
  "hero.feature_channels": "+25,000 قناة",
  "hero.feature_vod": "أفلام ومسلسلات 4K",
  "hero.feature_stable": "خدمة مستقرة 24/7",
  "hero.discover": "🔥 اكتشف عروضنا",
  "social.badge": "إثباتات الدفع",
  "social.title1": "+10,000 عميل",
  "social.title2": "راضٍ",
  "social.desc": "إثباتات حقيقية من عملائنا — مدفوعات موثقة واشتراكات مفعّلة مباشرة",
  "social.stat1_val": "+10,000",
  "social.stat1_label": "عميل راضٍ",
  "social.stat2_val": "4.8/5",
  "social.stat2_label": "تقييم العملاء",
  "social.stat3_val": "7 أيام",
  "social.stat3_label": "ضمان استرداد المال",
  "pricing.badge": "💎 عروض حصرية",
  "pricing.title": "اشتراك البث المميز",
  "pricing.subtitle": "🎥 وصول غير محدود لـ +70,000 فيلم وسلسلة + 25,000 قناة تلفزيونية مباشرة - جودة 4K مضمونة بلا انقطاع!",
  "pricing.premium_badge": "بريميوم",
  "pricing.premium_title": "عرض بريميوم",
  "pricing.premium_sub": "أساسيات البث عالي الجودة",
  "pricing.gold_badge": "بريميوم جولد",
  "pricing.gold_title": "بريميوم",
  "pricing.gold_title2": "جولد",
  "pricing.gold_sub": "تجربة البث المطلقة • الكل شامل",
  "pricing.gold_desc1": "استمتع بوصول غير محدود لأكثر من <b>25,000 قناة مباشرة</b> وأكثر من <b>70,000 فيلم ومسلسل</b>",
  "pricing.recommended": "موصى به",
  "pricing.months3": "3 أشهر",
  "pricing.months6": "6 أشهر",
  "pricing.months12": "12 شهراً",
  "pricing.months1": "شهر واحد",
  "pricing.per_month1": "79 درهم/شهر",
  "pricing.per_month3": "50 درهم/شهر",
  "pricing.per_month6": "33 درهم/شهر",
  "pricing.per_month12": "25 درهم/شهر",
  "pricing.per_month1g": "99 درهم/شهر",
  "pricing.per_month3g": "66 درهم/شهر",
  "pricing.per_month6g": "50 درهم/شهر",
  "pricing.per_month12g": "42 درهم/شهر",
  "pricing.bonus": "🎁 اشتراك ثانٍ بـ 45 USD",
  "pricing.replay": "إعادة 24 ساعة",
  "pricing.per_month_suffix": "شهر",
  "pricing.btn_test": "🛒 اشتر الآن",
  "pricing.btn_choose": "🔥 اشتر الآن",
  "pricing.card_discount": "💳 خصم 10% عند الدفع ببطاقة بنكية",
  "pricing.payment_title": "طرق الدفع المقبولة",
  "pricing.secure": "دفع آمن",
  "pricing.instant": "تفعيل فوري",
  "pricing.dedicated": "دعم مخصص",
  "pricing.premium_compare": "بريميوم: تطبيق واحد",
  "pricing.gold_compare": "جولد: 3 تطبيقات على نفس الجهاز",
  "pricing.f1": "جودة HD/4K على جميع شاشاتك",
  "pricing.f2": "تطبيق واحد مشمول إن كان الجهاز متوافقاً",
  "pricing.f3": "جهاز واحد متصل في نفس الوقت",
  "pricing.f4": "تفعيل فوري في 5 دقائق",
  "pricing.f5": "دعم واتساب 7 أيام/7",
  "pricing.f6": "متوافق مع Smart TV, Box, Mobile, PC",
  "pricing.f7": "تحديثات تلقائية",
  "pricing.f8": "قنوات دولية مشمولة",
  "pricing.gf1": "جودة 4K Ultra HD المميزة",
  "pricing.gf2": "تطبيق واحد مشمول إن كان الجهاز متوافقاً",
  "pricing.gf3": "جهاز واحد متصل في نفس الوقت",
  "pricing.gf4": "تقنية Anti-Freeze الحصرية",
  "pricing.gf5": "إعادة 24 ساعة على بعض القنوات",
  "pricing.gf6": "دليل EPG الإلكتروني الكامل",
  "pricing.gf7": "دعم أولوية 24/7",
  "pricing.gf8": "متوافق مع جميع الأجهزة",
  "pricing.gf9": "تحديثات تلقائية",
  "pricing.gf10": "محتوى دولي مميز",
  "pricing.gf11": "مكتبة VOD واسعة — أفلام ومسلسلات",
  "pricing.gf12": "تفعيل فوري في 5 دقائق",
  "pricing.s1_val": "+25,000", "pricing.s1_sub": "قناة HD/4K",
  "pricing.s2_val": "+70,000", "pricing.s2_sub": "فيلم ومسلسل",
  "pricing.s3_val": "تطبيق", "pricing.s3_sub": "مشمول\u00a0\u00a0إن كان الجهاز متوافقاً",
  "pricing.s4_val": "مستقر", "pricing.s4_sub": "الاتصال",
  "pricing.gs1_val": "+25,000", "pricing.gs1_sub": "قناة 4K",
  "pricing.gs2_val": "+70,000", "pricing.gs2_sub": "فيلم ومسلسل",
  "pricing.gs3_val": "1 تطبيق", "pricing.gs3_sub": "على جهاز واحد\u00a0إن كان الجهاز متوافقاً",
  "pricing.gs4_val": "مضاد للتجمد", "pricing.gs4_sub": "تقنية",
  "why.badge": "المزايا",
  "why.title": "لماذا تختارنا!",
  "why.desc": "7 سنوات من الخبرة في البث المميز مع آلاف العملاء الراضين",
  "why.exp": "سنوات من الخبرة",
  "why.exp_val": "7 سنوات",
  "why.b1_title": "ضمان الرضا أو استرداد المال",
  "why.b1_desc": "إذا لم تكن راضياً تماماً في الأسبوع الأول، سنرد لك المبلغ كاملاً — دون أسئلة. رضاك هو أولويتنا.",
  "why.b2_title": "تفعيل فوري",
  "why.b2_desc": "بمجرد التسجيل، تحصل على وصول فوري ببيانات الدخول. ابدأ المشاهدة فوراً.",
  "why.b3_title": "أفضل الأسعار في السوق",
  "why.b3_desc": "لن تجد قيمة أفضل مقابل المال بمثل هذه المعايير الجودة. أسعار لا تُنافَس.",
  "why.b4_title": "أفضل القنوات والـ VoD",
  "why.b4_desc": "خدمة VoD لدينا تمنحك وصولاً لأحدث الأفلام والمسلسلات. قنوات مباشرة وPay-Per-View متاحة.",
  "why.b5_title": "دعم العملاء 24/7",
  "why.b5_desc": "نحن متاحون على مدار الساعة. سواء نهاراً أو ليلاً، فريقنا مستعد لمساعدتك. تواصل معنا في أي وقت.",
  "devices.badge": "📺 التوافق",
  "devices.title1": "متوافق مع",
  "devices.title2": "جميع أجهزتك",
  "devices.desc": "ثبّت في أقل من دقيقتين على أي جهاز واستمتع بالبث في أي مكان.",
  "devices.note": "✅ التثبيت بإرشاد فريقنا التقني • ✅ المساعدة عن بُعد متاحة",
  "devices.d1": "Smart TV", "devices.d1s": "Samsung, LG, Sony, Philips…",
  "devices.d2": "Android TV", "devices.d2s": "صندوق أندرويد، Nvidia Shield…",
  "devices.d3": "Fire Stick", "devices.d3s": "Amazon Fire TV Stick 4K",
  "devices.d4": "الهاتف الذكي", "devices.d4s": "iOS & Android",
  "devices.d5": "اللوحي", "devices.d5s": "iPad, Samsung Tab…",
  "devices.d6": "الكمبيوتر", "devices.d6s": "Windows, Mac, Linux",
  "guarantee.title": "ضمان",
  "guarantee.title2": "الرضا أو استرداد المال",
  "guarantee.desc": "اختبر خدمتنا لمدة <b>7 أيام</b>. إذا لم تكن راضياً، سنرد لك المبلغ كاملاً — بدون أسئلة.",
  "guarantee.g1_title": "استرداد 100%",
  "guarantee.g1_desc": "استرداد كامل إذا لم تناسبك الخدمة",
  "guarantee.g2_title": "7 أيام للتجربة",
  "guarantee.g2_desc": "أسبوع كامل لاكتشاف جميع المميزات",
  "guarantee.g3_title": "دعم مخصص",
  "guarantee.g3_desc": "فريقنا يرافقك طوال فترة تجربتك",
  "world.badge": "التغطية الدولية",
  "world.title1": "بث التلفزيون",
  "world.title2": "في كل مكان بالعالم",
  "world.desc": "بغض النظر عن مكان تواجدك، خدمتنا متاحة دولياً.",
  "world.c_ma": "المغرب", "world.c_fr": "فرنسا", "world.c_sn": "السنغال",
  "world.c_be": "بلجيكا", "world.c_es": "إسبانيا", "world.c_gb": "المملكة المتحدة",
  "world.c_it": "إيطاليا", "world.c_ca": "كندا", "world.c_us": "الولايات المتحدة",
  "world.c_de": "ألمانيا", "world.c_ch": "سويسرا", "world.c_pt": "البرتغال",
  "world.c_nl": "هولندا", "world.c_tn": "تونس", "world.c_dz": "الجزائر",
  "world.c_ci": "ساحل العاج", "world.c_cm": "الكاميرون", "world.c_sa": "المملكة العربية السعودية",
  "world.c_ae": "الإمارات", "world.c_qa": "قطر",
  "trial.title": "تجربة مجانية 24 ساعة",
  "trial.desc": "اختبر خدمتنا 24 ساعة مجاناً. بدون التزام، بدون بطاقة ائتمان.",
  "trial.form_title": "تواصل مباشر",
  "trial.success_title": "تم إرسال الطلب!",
  "trial.success_desc": "سنتواصل معك قريباً جداً على واتساب.",
  "trial.name_label": "الاسم الكامل",
  "trial.name_placeholder": "اسمك الكامل",
  "trial.phone_label": "رقم الهاتف",
  "trial.phone_placeholder": "رقم هاتفك",
  "trial.city_label": "الدولة",
  "trial.city_placeholder": "دولتك",
  "trial.submit": "احصل على التجربة عبر واتساب",
  "trial.sending": "جارٍ الإرسال...",
  "trial.h1": "24 ساعة كاملة",
  "trial.h1d": "وصول غير محدود لمدة 24 ساعة لجميع خدماتنا",
  "trial.h2": "بدون التزام",
  "trial.h2d": "لا تحتاج لبطاقة ائتمان، إلغاء تلقائي",
  "trial.h3": "تفعيل فوري",
  "trial.h3d": "استلم بياناتك عبر البريد الإلكتروني في أقل من 5 دقائق",
  "trial.what_title": "ما يمكنك تجربته:",
  "trial.w1": "جميع القنوات\nرياضة، أخبار، ترفيه، أطفال...",
  "trial.w2": "مكتبة كاملة\n+70,000 فيلم ومسلسل",
  "trial.w3": "جودة مميزة\nجودة 4K وFull HD",
  "faq.badge": "الأسئلة الشائعة",
  "faq.title1": "الأسئلة",
  "faq.title2": "الشائعة",
  "faq.desc": "كل ما تحتاج معرفته قبل الاشتراك",
  "faq.more": "هل لديك أسئلة أخرى؟",
  "faq.cta": "تواصل معنا على واتساب",
  "faq.q1": "كيف تعمل خدمة البث لديكم؟",
  "faq.a1": "خدمة IPTV لدينا تتيح مشاهدة +25,000 قناة مباشرة و+70,000 فيلم ومسلسل عبر الإنترنت على جميع أجهزتك. بعد الدفع، تستلم بياناتك في 5 دقائق.",
  "faq.q2": "على أي أجهزة يمكنني استخدام الخدمة؟",
  "faq.a2": "متوافق مع Smart TV (Samsung, LG, Sony) وAndroid TV وFire Stick والهواتف iOS & Android والأجهزة اللوحية وأجهزة الكمبيوتر Windows/Mac/Linux.",
  "faq.q3": "ما سرعة الإنترنت المطلوبة؟",
  "faq.a3": "الحد الأدنى 10 ميجابت للثانية للـ HD، و25 ميجابت للثانية للـ 4K. يُنصح باستخدام الألياف الضوئية أو 4G/5G.",
  "faq.q4": "كيف تعمل التجربة المجانية 24 ساعة؟",
  "faq.a4": "املأ النموذج أعلاه. سنرسل لك بيانات التجربة عبر واتساب في أقل من 5 دقائق، بدون بطاقة ائتمان.",
  "faq.q5": "هل الخدمة موثوقة؟ هل هناك انقطاعات؟",
  "faq.a5": "تستخدم خوادمنا تقنية Anti-Freeze بنسبة توفر 99.9%. لدينا خوادم احتياطية لضمان بث مستقر.",
  "faq.q6": "ما طرق الدفع المقبولة؟",
  "faq.a6": "Visa/Mastercard (خصم 10%) والتحويل البنكي وWafacash وCashPlus وPayPal وRemitly وWestern Union وBinance والحساب الأوروبي.",
  "faq.q7": "كم يستغرق التفعيل؟",
  "faq.a7": "تفعيل فوري في أقل من 5 دقائق بعد تأكيد الدفع، 7 أيام/7 من 10 صباحاً إلى 12 منتصف الليل.",
  "faq.q8": "هل يمكنني استخدام الخدمة في الخارج؟",
  "faq.a8": "نعم، الخدمة تعمل في جميع أنحاء العالم: أوروبا، أفريقيا، أمريكا، الشرق الأوسط. أياً كان مكانك، الوصول مضمون.",
  "support.title": "دعم العملاء 24/7",
  "support.desc": "فريق مخصص لمرافقتك في كل خطوة من تجربتك الرقمية",
  "support.channels_title": "تواصل معنا عبر قناتك المفضلة",
  "support.cta_whatsapp": "تواصل مع الدعم",
  "support.note": "💬 واتساب • 📞 هاتف • 📧 بريد إلكتروني • 🏠 زيارة منزلية",
  "support.s1_title": "واتساب",
  "support.s1_desc": "دعم فوري عبر واتساب",
  "support.s1_speed": "< 5 دقائق",
  "support.s1_hours": "24/7",
  "support.s2_title": "الهاتف",
  "support.s2_desc": "مساعدة هاتفية مباشرة",
  "support.s2_speed": "فوري",
  "support.s2_hours": "10ص-12م",
  "support.s3_title": "البريد الإلكتروني",
  "support.s3_desc": "دعم تقني عبر البريد الإلكتروني",
  "support.s3_speed": "< ساعتان",
  "support.s3_hours": "24/7",
  "support.s4_title": "زيارة منزلية",
  "support.s4_desc": "تدخل تقني في منزلك",
  "support.s4_speed": "24-48 ساعة",
  "support.s4_hours": "الاثنين-السبت",
  "support.s4_contact": "بموعد مسبق",
  "cta.title": "ابدأ المشاهدة اليوم",
  "cta.desc": "انضم إلى +10,000 عميل راضٍ. فعّل اشتراكك في 5 دقائق واستمتع بـ +25,000 قناة.",
  "cta.expires": "ينتهي العرض الترويجي خلال",
  "cta.btn1": "جرّب الآن",
  "cta.btn2": "تجربة مجانية 24 ساعة",
  "cta.note": "✅ دفع آمن • ✅ تفعيل فوري • ✅ ضمان 7 أيام",
  "whatsapp.tooltip": "تحدث معنا!",

  "footer.services": "الخدمات",
  "footer.contact": "التواصل",
  "footer.coverage": "التغطية",
  "footer.legal": "القانوني",
  "footer.copyright": "Onetvservices 2019-2026 © جميع الحقوق محفوظة",
  "footer.s1": "اشتراكات مميزة",
  "footer.s2": "أفلام ومسلسلات 4K",
  "footer.s3": "الرياضة المباشرة",
  "footer.s4": "دعم 24/7",
  "footer.cov1": "🌍 أوروبا",
  "footer.cov2": "🌍 أمريكا",
  "footer.cov3": "🌍 أفريقيا",
  "footer.cov4": "🌍 العالم",
  "footer.l1": "عنّا",
  "footer.l2": "الشروط العامة",
  "footer.l3": "سياسة الخصوصية",
  "footer.l4": "سياسة الاسترداد",
  "footer.l5": "التواصل",
};

export default translations;
